<template>
<div class="chapter">
<div class="inner_page">
<div class="section level2" id="july">
<h2>July</h2>
<p>The summer heat</p>
<p>Hanging heavy in the air</p>
<p>Peonies on the table</p>
<p>Opening at a languid pace</p>
<p>White cotton sheets</p>
<p>Rumpled on the bed</p>
<p>The sound of your footsteps</p>
<p>Tracing the hardwood floor</p>
<p>The hands of the broken clock</p>
<p>Standing silently in place</p>
<p>The promise of what could be</p>
<p>As eternal as those summer days.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?057f79f4